"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineFieldsDeliverableMapping = void 0;
var TimelineFieldsDeliverableMapping;
(function (TimelineFieldsDeliverableMapping) {
    let deliverableType;
    (function (deliverableType) {
        deliverableType["BOT_COMMAND"] = "botCommand";
        deliverableType["BRIEF"] = "brief";
        deliverableType["CONTRACT"] = "contract";
        deliverableType["CREATOR_PAY_PER_EVENT"] = "creatorPayPerEvent";
        deliverableType["LIVE_STREAM"] = "liveStream";
        deliverableType["OVERLAY"] = "overlay";
        deliverableType["PANEL_BANNER"] = "panelBanner";
        deliverableType["PAY_PER_EVENT"] = "payPerEvent";
        deliverableType["PAY_PER_EVENT_BRACKET"] = "payPerEventBracket";
        deliverableType["CUSTOM"] = "custom";
        deliverableType["DYNAMIC_DESCRIPTION_WIDGET"] = "dynamicDescriptionWidget";
        deliverableType["TIK_TOK_CREATIVE"] = "tikTokCreative";
        deliverableType["YOU_TUBE_VIDEO"] = "youTubeVideo";
        deliverableType["MARKDOWN_BRIEF"] = "markdownBrief";
    })(deliverableType = TimelineFieldsDeliverableMapping.deliverableType || (TimelineFieldsDeliverableMapping.deliverableType = {}));
})(TimelineFieldsDeliverableMapping = exports.TimelineFieldsDeliverableMapping || (exports.TimelineFieldsDeliverableMapping = {}));
